<!--  <div>无人机/车 急救实况</div>-->
<template>
  <div class="show-ambulance">
    <div class="video-container">
      <div class="video-player">
        <car-video
          ref="video"
          :video-src="videoType1"
          :car-width="815"
          :car-height="555"
        />
        <!--这种属于直播类型的监控视频,只有 护士 || 信息科 需要请求权限-->
        <el-button
          v-if="isNurse && hasVideo && !hasPermission"
          class="permission-button"
          @click="getPermissionForLive"
        >
          <!-- 如果是护士的话,再看看有没有权限 -->
          请求权限
        </el-button>
        <span v-if="!hasVideo" class="permission-button">
          暂无视频
        </span>
        <!--        以后再写这里面的-->
      </div>
    </div>
    <div class="map-container">
      <div class="map-row">
        <div class="predicateTime">
          预计返程时间：
          <span>{{ leftTime }}分钟</span>
        </div>
        <live-map
          v-if="carID"
          :car-i-d="carID"
          :category="category"
          :width="620"
          :height="600"
          @getLeftTime="getLeftTime"
        />
      </div>
    </div>
    <el-switch
      v-model="isOpenMic"
      active-color="#13ce66"
      inactive-color="#ff4949"
      active-text="打开麦克风"
      inactive-text="关闭麦克风"
    />
    <div class="record-detail" @click="isShowDrawer = true">
      <i class="el-icon-arrow-left"/>
      <span>详情</span>
    </div>
    <div class="drawer-container">
      <my-drawer-single :drawer="isShowDrawer" @closeDrawer="isShowDrawer=false"/>
    </div>
    <my-dialog
      :dialog-carted="infoDialog"
      form-title="提示"
      :width="320"
      @confirmOk="infoDialog = false"
    >
      <template #content>
        <div>{{ infoDialogMessage }}</div>
      </template>
    </my-dialog>
  </div>
</template>
<script>
import CarVideo from "@components/stream/CarVideo";
import MyDrawerSingle from "@components/Drawers/MyDrawerSingle";
import LiveMap from "@components/MapContainer/LiveMap";
import { askPermission } from "@api/permission";
import { getPushStreamToken, getStreamToken } from "@api/streamdata";
import { SrsRtcPublisherAsync } from "@utils/rtc";
import { srsRtcUrl } from "@utils/basic";
import { mapState } from "vuex";
import MyDialog from "@components/customDialog/MyDialog";
import { showWindowMessage } from "@utils/notification";

export default {
  name: "SmartLive",
  components: {
    MyDrawerSingle,
    LiveMap,
    CarVideo,
    MyDialog,
  },
  data() {
    return {
      leftTime: 0, // 急救车返程时间
      carID: "", // 当前急救车id
      isShowDrawer: false, // 展示Drawer 抽屉
      isOpenMic: false, // 是否打开麦克风推流
      videoType2: "webrtc://", // 救护仪器
      videoType1: "webrtc://", // 摄像头和麦克风
      patientID: "", // 当前急救车接送/处理 的病人ID
      isNurse: false, // 判断是否为护士登陆
      hasPermission: false, // 总的判断是否有权限
      hasVideo: false, // 当前是否有视频(需要显示权限的)
      infoDialog: false,
      infoDialogMessage: "",
      publisher: null,
      category: "",
    };
  },
  computed: {
    ...mapState({
      ambulanceLists: "ambulanceLists",
      currentList: "currentList",
      hospitalID: "hospitalID",
      userInfo: "userInfo",
    }),
  },
  watch: {
    isOpenMic: {
      handler(val) {
        if (val) {
          this.startPushAudio();
        } else {
          this.publisher && this.publisher.close();
        }
      },
      immediate: true
    }
  },
  beforeUnmount() {
    if (this.publisher) {
      this.publisher.close();
    }
  },
  mounted() {
    this.isNurse = (this.userInfo.loginUserId === 3);
    this.category = this.$route.query.category;
    this.carID = Number(this.$route.params.id);
    // 刷新视频的同时, 刷新音频
    this.getStreamInfo();
  },
  methods: {
    getLeftTime(leftTime) {
      this.leftTime = Math.round(leftTime / 60);
    },
    async getPermissionForLive() {
      const item = this.currentList.find(e => {
        return e.ambulanceId === this.carID;
      });
      const { id: userId } = this.userInfo;
      const form = {
        type: "checkLive",
        hospitalId: this.hospitalID,
        ambulanceId: this.carID,
        medicalhistoryId: item?.id,
        userId
      };
      try {
        // 如果护士没有权限,则去请求权限
        const { msg } = await askPermission(form);
        this.infoDialog = true;
        this.infoDialogMessage = msg;
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
    // 推流麦克风
    startPushAudio() {
      getPushStreamToken(this.carID).then(({ code, token, car_number, audio_can }) => {
        if (code !== 200) return;
        if (audio_can !== 1) {
          this.isOpenMic = false;
          alert("麦克风只能同时被一个用户使用, 当前有其他用户正在使用, 不允许使用, 请稍后再试!");
          return;
        }

        this.publisher = new SrsRtcPublisherAsync();
        const url = srsRtcUrl + `${car_number}/${car_number}-audio?token=${token}`;
        this.publisher.publish(url)
          .then(() => {
            console.log("ee");
          })
          .catch(e => {
            console.log(e);
          });
      }).catch(e => console.log(e));
    },
    // 拉取webrtc视频流 || 进来的时候 (两个都拉)
    async getStreamInfo() {
      // 判断是否有打开麦克风, 有的话, 也要重新连接

      try {
        if (this.isOpenMic) {
          this.publisher && this.publisher.close();
          this.startPushAudio();
        }
        const { code, data } = await getStreamToken(this.carID);
        if (code === 405) {
          this.hasVideo = true;
        }
        if (code === 200) {
          const type1 = data.find(e => {
            this.hasVideo = true;
            this.hasPermission = true;
            return e.type === 5 || e.type === 4;
          });
          // const type2 = data.find(e => {
          //   return e.type === 4;
          // });
          if (type1) {
            this.hasVideo = true;
            this.videoType1 = srsRtcUrl + `${type1.app}/${type1.stream}?token=${type1.token}&time=${Date.now()}`; // 摄像头和麦克风
          }
          // if (type2) {
          //   this.videoType2 = srsRtcUrl + `${type2.app}/${type2.stream}?token=${type2.token}&time=${Date.now()}`; // 救护仪器
          // }
        } else {
          this.videoType1 = srsRtcUrl + "";
          // this.videoType2 = srsRtcUrl + "";
        }
      } catch (e) {
        showWindowMessage(3, e, this);

      }
    },
    // 拉取监护仪
    // async getStreamInfo1() {
    //   // 判断是否有打开麦克风, 有的话, 也要重新连接
    //   const { code, data } = await getStreamToken(this.carID);
    //   if (code === 200 || code === 405) {
    //     const type2 = data.find(e => {
    //       return e.type === 2;
    //     });
    //     if (type2) {
    //       this.videoType2 = srsRtcUrl + `${type2.app}/${type2.stream}?token=${type2.token}&time=${Date.now()}`; // 救护仪器
    //     }
    //   } else {
    //     this.videoType2 = srsRtcUrl + "";
    //   }
    // },
    // 拉取监控
    async getStreamInfo2() {
      try {
        // 判断是否有打开麦克风, 有的话, 也要重新连接
        if (this.isOpenMic) {
          this.publisher && this.publisher.close();
          this.startPushAudio();
        }
        const { code, data } = await getStreamToken(this.carID);
        if (code === 405) {
          this.hasVideo = true;
        }
        if (code === 200) {
          const type1 = data.find(e => {
            return e.type === 5 || e.type === 4;
          });
          if (type1) {
            this.hasPermission = true;
            this.hasVideo = true;
            this.videoType1 = srsRtcUrl + `${type1.app}/${type1.stream}?token=${type1.token}&time=${Date.now()}`; // 摄像头和麦克风
          }
        } else {
          this.videoType1 = srsRtcUrl + "";
        }
      } catch (e) {
        showWindowMessage(3, e, this);

      }
    },
  }
};
</script>
<style scoped lang="scss">
.show-ambulance {
  margin-top: 24px;
  display: flex;
}

.video-container {
  width: 864px;
  height: 660px;
  background: #FBFBFB;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .video-player {
    width: 816px;
    height: 556px;
    background: #666666;
    border-radius: 10px;
  }

  .video-control {
    width: 816px;
    height: 56px;
    background: #666666;
    opacity: 0.19;
    border-radius: 0 0 10px 10px;
  }
}

.map-container {
  width: 660px;
  height: 660px;
  background: #FBFBFB;
  border-radius: 10px;
  margin-left: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  .map {
    width: 617px;
    height: 612px;
    border-radius: 10px;
    background: #333;
  }

  .map-row {
    position: relative;

    .predicateTime {
      position: absolute;
      left: 10px;
      bottom: 4px;
      z-index: 161;
      text-align: center;
      vertical-align: bottom;
      line-height: 50px;
      font-size: 22px;
      font-weight: bold;
      color: #666666;
      width: 260px;
      height: 48px;
      background: #FBFBFB;
      box-shadow: 0 0 8px 0 rgba(127, 147, 166, 0.4);
      border-radius: 10px;
    }
  }
}

.assistant-help {
  cursor: pointer;
  width: 84px;
  height: 28px;
  background: #fbfbfb;
  border-radius: 14px;
  font-size: 14px;
  color: #666666;
  margin: auto;
  line-height: 28px;
  text-align: center;
}

.assistant-dialog ::v-deep {

  .el-dialog__body {
    padding: 24px;
    text-align: left;
  }

  .el-input__inner {
    width: 140px;
    height: 32px;
    border: 1px solid #999999;
    border-radius: 10px;
    box-shadow: none;
    background: transparent;
  }

  .el-checkbox__inner {
    width: 20px;
    height: 20px;
    border: 1px solid #999999;
    border-radius: 6px;
  }

  .el-checkbox__label {
    font-size: 16px;
    font-weight: 400;
    color: #999999;
  }
}

.record-detail {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 52px;
  height: 62px;
  background: #FBFBFB;
  border-radius: 10px 0 0 10px;
  cursor: pointer;

  span {
    -webkit-writing-mode: vertical-rl;
    writing-mode: vertical-rl;
  }
}

.drawer-container ::v-deep {
  .el-drawer__body {
    padding: 24px 30px;
  }

  .el-tabs,
  .el-tabs__content,
  .el-tab-pane {
    overflow: auto;
  }
}

.el-switch {
  position: absolute;
  right: 0;
  bottom: 0;
}

.video-player {
  position: relative;

  .permission-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
